/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IlsForExport } from '../../models/ils-for-export';

export interface IlsControllerExportIls$Params {
  ilsId: string;
}

export function ilsControllerExportIls(http: HttpClient, rootUrl: string, params: IlsControllerExportIls$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsForExport>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerExportIls.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IlsForExport>;
    })
  );
}

ilsControllerExportIls.PATH = '/ils/{ilsId}/export';
